import { Sites } from '@ps/platform-message-framework/common/Sites';
import {
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  mustNotContainNumber,
  mustNotContainSymbols,
  noWhiteStartOrEnd
} from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTCLI_Optional,
  TXTWCL_Middle_name_or_initial,
  TXTWCL_The_name_you_have_entered_is_i_ELL
} from './MiddleName.messages.json';

const MiddleName = () => {
  const { formatMessage } = useIntl();
  const isCAON = useSelector(select.cms.getSiteId) === Sites.CA_ON;
  const {
    input: { value }
  } = useField('middleName');

  return isCAON ? (
    <TextInput
      id="middleName"
      value={value}
      maxLength={50}
      label={TXTWCL_Middle_name_or_initial}
      placeholder={formatMessage(TXTCLI_Optional)}
      checkDisabled
      validators={[
        noWhiteStartOrEnd,
        mustNotContainNumber(TXTWCL_The_name_you_have_entered_is_i_ELL, true),
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_name_you_have_entered_is_i_ELL
        )
      ]}
    />
  ) : null;
};

export default MiddleName;
